/**
 * AWS Amplify configuration.
 * Fill in the values from CDK outputs after deploying the infrastructure.
 * These values are found in the CloudFormation outputs for DataOneAuth stack.
 */
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_COGNITO_WEB_CLIENT_ID as string,
      region: import.meta.env.VITE_AWS_REGION ?? 'ap-south-1',
    },
  },
};

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
